import BaseClient from './BaseClient';

class OrgUnitInvitationsClient extends BaseClient {
    listInvitations(teamId, orgUnitId, params) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/invitations`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    invitationsCount(teamId, orgUnitId, params) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/invitations/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    sendInvitation(teamId, orgUnitId, params) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/invitations`;
        return this.makeCoreApiRequest(url, 'post', params);
    }

    resendInvitation(teamId, orgUnitId, invitationId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/invitations/${invitationId}`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteInvitation(teamId, orgUnitId, invitationId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/invitations/${invitationId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new OrgUnitInvitationsClient();
